import { Injectable } from '@angular/core';

const TOKEN_KEY = 'mortgage-workflow-token';
const REFRESH_TOKEN_KEY = 'mortgage-workflow-refresh';

@Injectable({
  providedIn: 'root',
})
export class TokenRepository {
  private token: string | null;
  private refreshToken: string | null;

  constructor() {
    this.token = localStorage.getItem(TOKEN_KEY);
    this.refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  public getToken(): string | null {
    return this.token;
  }

  public setToken(token: string | null): void {
    this.token = token;

    token
      ? localStorage.setItem(TOKEN_KEY, token)
      : localStorage.removeItem(TOKEN_KEY);
  }

  public getRefreshToken(): string | null {
    return this.refreshToken;
  }

  public setRefreshToken(refreshToken: string | null): void {
    this.refreshToken = refreshToken;

    refreshToken
      ? localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
      : localStorage.removeItem(REFRESH_TOKEN_KEY);
  }
}
